import type { ArgsOf, RequestOf } from "@p0security/shared/types/access/index";
import { Access } from "@p0security/shared/types/access/index";

export const OracleAccesses = {
  group: Access({
    description: "Group access to Oracle Cloud resources",
    label: "Group access",
    delegation: {},
    generated: {
      userId: {
        type: "string",
        label: "User OCID",
        description: "The OCID of the user to add to the group",
      },
    },
    maturity: "preview",
    parameters: {
      // TODO: this is backwards, should have static "domain" and generated "domainId"
      domainId: {
        type: "static",
        label: "Domain OCID",
        description: "The OCID of the domain where the group exists",
      },
      domainName: {
        type: "generated",
        label: "Domain name",
        description: "The name of the domain where the group exists",
      },
      compartmentId: {
        type: "generated",
        label: "Compartment OCID",
        description:
          "The OCID of the compartment where the group access will be granted",
      },
      compartmentName: {
        type: "generated",
        label: "Compartment name",
        description:
          "The name of the compartment where the group access will be granted",
      },
      groupId: {
        type: "static",
        label: "Group OCID",
        description: "The OCID of the group to grant access to",
      },
      groupName: {
        type: "generated",
        label: "Group name",
        description: "The name of the group to grant access to",
      },
    },
    render: { locator: "domainName", policy: "groupName" } as const,
  }),
};

export type OracleAccesses = typeof OracleAccesses;

export type OracleAccess = OracleAccesses[keyof OracleAccesses];
export type OracleGroupAccess = OracleAccesses["group"];
export type OracleGroupAccessArgs = ArgsOf<OracleGroupAccess>;
export type OracleGroupAccessRequest = RequestOf<OracleGroupAccess>;
